import $ from "jquery";

$(document).on("click", ".content-more", function () {
  const $contentShort = $(".details__bottom .content-short");
  const $contentFull = $(".details__bottom .content-full");
  const $moreButton = $(this);

  if ($contentFull.is(":visible")) {
    $contentFull.hide();
    $contentShort.show();
    $moreButton.text($moreButton.data("more"));
  } else {
    $contentFull.show();
    $contentShort.hide();
    $moreButton.text($moreButton.data("less"));
  }
});
